<template>
    <section>
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold singleline">Rent vs buy calculator</h2>
            <mvtNearbyAfford ref="nearbyafford" @update="updateAffordInfo" :income="dpp.price" :state="dpp.geo.state" :cityCode="dpp.geo.cityCode" :bed="dpp.bed" :bath="dpp.bath"></mvtNearbyAfford>
        </div>
    </section>
</template>
<script src="./dpp-nearbyafford.js"></script>
